<template>
  <div>
    <Header :isactive='5' :ischunrk='true' :key="new Date().getTime()"/>
    <div style="height: 60px;"></div>
    <div id="banner">
      <!-- {background:'url('+require('@/assets/image/banner-contact.jpg')+') center center no-repeat'} -->
      <img src="@/assets/image/banner-contact.jpg" alt="">
    </div>
    <div id="contact-us">
      <div class="us-content">
        <div class="title-content">
          <p class="trans">CONTACT US</p>
          <p class="title">联系我们</p>
          <p class="trans">029-81154580</p>
        </div>
        <div class="us-list">
          <div class="us-item left">
            <div class="bg-us-1 left">
              <img src="@/assets/image/bg-us-1.png" alt="">
            </div>
            <div class="title-box left">
              <p class="title">合作洽谈</p>
              <img src="@/assets/image/business.png" alt="" class="trans">
            </div>
          </div>
          <div class="us-item right">
            <div class="bg-us-1 left">
              <img src="@/assets/image/bg-us-2.png" alt="">
            </div>
            <div class="title-box left">
              <p class="title">简历投递</p>
              <img src="@/assets/image/hr.png" alt="" class="trans">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div id="address">-->
    <!--      <div class="ad-content">-->
    <!--        <div class="title-content">-->
    <!--          <p class="trans">COMPANY ADDRESS</p>-->
    <!--          <p class="title">公司地址</p>-->
    <!--        </div>-->
    <!--        <div class="ad-list">-->
    <!--          <img src="@/assets/image/local.png" alt="" class="local">-->
    <!--          <img src="@/assets/image/company-address.png" alt="">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      ad5: false,
      ad6: false,
      ad7: false,
      ad8: false
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}

</script>
<style lang='scss' scoped>
$active: #13c2c2;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

#contact-us {
  padding: 120px 0px;
  background: rgba(248, 248, 248, 1);

  .us-content {
    width: $width;
    margin: 0 auto;

    .us-list {
      margin-top: 60px;
      height: 172px;

      .us-item {
        width: 588px;
        height: 172px;
        box-shadow: 0px 4px 40px 0px rgba(74, 144, 226, 0.15);
        border-radius: 10px;

        .bg-us-1 {
          margin-left: 60px;
          width: 234px;

          img {
            margin-top: 27px;
            margin-left: 35px;
          }
        }

        .title-box {
          padding-left: 8px;

          .title {
            margin-top: 60px;
            font-size: 20px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
          }

          .trans {
            margin-top: 8px;
          }
        }
      }
    }
  }
}

#banner {
  width: 100%;
  /* height: 482px; */

  img {
    width: 100%;
    /* min-width: 1920px; */
    display: block;
  }
}

#address {
  padding: 120px 0px;

  .ad-content {
    width: $width+40;
    margin: 0 auto;

    .ad-list {
      margin-top: 80px;
      position: relative;

      .local {
        position: absolute;
        width: 30px;
        height: 30px;
        left: 905px;
        bottom: 155px;
        cursor: pointer;
        overflow: hidden;
        -webkit-animation-timing-function: ease-in-out;
        -webkit-animation-name: breathe;
        -webkit-animation-duration: 2700ms;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-direction: alternate;

      }

      @-webkit-keyframes breathe {
        0% {
          opacity: .2;
        }

        100% {
          opacity: 1;
        }
      }

      img {
        height: 100%;
        display: block;
      }
    }
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
